














































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import signList from '@/views/sign/component/signList.vue';
import confirmDialog from '@/components/common/confirmDialog.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import {
  TrainClassDto,
  ClassState,
  // ClassSolutionSignInSchedule,
} from '@/api/models';
import moment from 'moment';
@Component({ components: { signList, confirmDialog, confirmFeedback } })
export default class SignIndex extends Vue {
  activeName: string = '补签';
  signStatus: string = '补签';
  errorMsg: string = '';
  loading: boolean = false;
  finished: boolean = false;
  dialogShow: boolean = false;
  feedbackShow: boolean = false;
  dialogType: string = '';
  feedbackType: string = '';
  successStatu: boolean = false;
  // signList: ClassSolutionSignInSchedule[] = [];
  signInData: TrainClassDto[] = [];
  //时间、地点签到确认框专用
  signTime: string = '';
  signAddress: string = '';
  stateSwtich(name: string) {
    this.signStatus = name;
  }
  signSubmit(classItem: TrainClassDto) {
    //点击签到时，获取当前培训班所有的签到时间段列表
    this.getSignList(classItem.id!);
    this.dialogShow = true;
    this.dialogType = '签到';
    this.signTime = moment(new Date()).format('YYYY-MM-DD HH:mm');
    this.signAddress = classItem.address!;
  }
  //确认签到回调事件
  async confirmSubmit(val: any) {
    // let that = this;
    // this.dialogShow = false;
    // //判断当前时间是否在签到列表所设置的签到开始与截止时间内（是：允许签到，否：不允许签到）
    // if (that.signList.length > 0) {
    //   await that.signList.forEach(async (item, index) => {
    //     //当前签到时间在签到时间段内时，允许签到，将签到记录存储到签到记录表
    //     that.loading = true;
    //     //系统返回提交状态
    //     try {
    //       const { data, success, message } = await api.SolutionSignIn.studentSingIn_POST({
    //         openClassSolutionId: item.openClassSolutionId,
    //         signInScheduleId: "",
    //       });
    //       if (success) {
    //         that.successStatu = true;
    //         this.feedbackShow = true;
    //       } else {
    //         that.successStatu = false;
    //         that.errorMsg = "当前时间不在签到时间段内";
    //         this.feedbackShow = true;
    //       }
    //     } finally {
    //       that.loading = false;
    //       that.finished = true;
    //     }
    //   });
    // } else {
    //   that.successStatu = false;
    //   that.errorMsg = "当前时间不在签到时间段内";
    // }
    // that.feedbackType = "签到";
  }
  //取消签到回调事件
  confirmCancle() {
    this.dialogShow = false;
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
  //获取当前培训班的签到列表
  async getSignList(openClassSolutionId: string) {
    // const { data } = await api.SolutionSignIn.getSignInList_GET({
    //   openClassSolutionId: openClassSolutionId,
    // });
    // this.signList = data!;
  }
  //获取正在进行中签到的培训班
  async getSignInData() {
    this.loading = true;
    try {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: ClassState.培训中,
      });
      this.signInData = data!.items!;
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  mounted() {
    this.getSignInData();
  }
}
